import { ApplicationView, useController } from '@aha-app/mvc';
import classNames from 'classnames';
import React, { useState } from 'react';
import customElementBoolAttr from '../../../utils/customElementBoolAttr';
import VotingSessionController, {
  pokerDefaultChoices,
  type PokerPreset,
} from './controllers/VotingSessionController';
import styles from './VotingSession.module.css';
import { VotingSetupSelectedObjectsControls } from './VotingSetupSelectedObjectsControls';
import { VotingSetupSessionTypeControls } from './VotingSetupSessionTypeControls';
import { VotingSetupTimerControls } from './VotingSetupTimerControls';
import { VotingSetupVoteLimitControls } from './VotingSetupVoteLimitControls';
import { VotingSetupPokerOptions } from './VotingSetupPokerOptions';
import { VotingSessionType } from '../../../widgets/VotingSessionType';

export const pokerValuesFieldData: Record<PokerPreset, string> = {
  fibonacci: pokerDefaultChoices.fibonacci.join(', '),
  tshirt: pokerDefaultChoices.tshirt.join(', '),
  custom: '',
};

const VotingSetupForm = () => {
  const controller = useController(VotingSessionController);
  const { enabledFields } = controller;
  const { onlySelected, selectedObjects, sessionType, numObjects } =
    controller.state;

  const pokerPreset = controller.state.pokerPreset;
  let initialFieldValue = controller.state.pokerChoices.join(', ');
  if (pokerPreset !== 'custom') {
    initialFieldValue = pokerValuesFieldData[pokerPreset];
  }

  const [pokerCustomValuesField, setPokerCustomValuesField] = useState<{
    value: string;
    error: string | null;
  }>({ value: initialFieldValue, error: null });

  const selectedEnoughObjects = !onlySelected || selectedObjects.length > 1;
  const selectedTooManyObjects =
    selectedObjects.length > VotingSessionController.OBJECT_LIMIT ||
    (!onlySelected && numObjects > VotingSessionController.OBJECT_LIMIT);

  let ready = pokerCustomValuesField.error === null;
  if (enabledFields.onlySelected) {
    ready = selectedEnoughObjects && !selectedTooManyObjects;
  }

  return (
    <div className='flex-col gap-7'>
      <ol className={classNames('side-panel__list', styles.votingForm)}>
        {sessionType !== VotingSessionType.Poker && (
          <VotingSetupTimerControls />
        )}
        {enabledFields.votesLimited && <VotingSetupVoteLimitControls />}
      </ol>
      <aha-button
        disabled={customElementBoolAttr(!ready)}
        kind='primary'
        size='medium'
        onClick={() => {
          if (ready) {
            controller.actionSetPokerChoices(pokerCustomValuesField.value);
            controller.actionStartVotingSession();
          }
        }}
      >
        <i className='fa-solid fa-play mr-2' />
        Start
      </aha-button>

      <div className={styles.pokerCardSmall}>
        <VotingSetupSessionTypeControls />
        {enabledFields.onlySelected && (
          <VotingSetupSelectedObjectsControls
            numObjects={numObjects}
            onlySelected={onlySelected}
            selectedEnoughObjects={selectedEnoughObjects}
            selectedTooManyObjects={selectedTooManyObjects}
          />
        )}
        {sessionType === VotingSessionType.Poker && (
          <VotingSetupPokerOptions
            customValuesField={pokerCustomValuesField}
            setCustomValuesField={setPokerCustomValuesField}
          />
        )}
      </div>
    </div>
  );
};

export default ApplicationView(VotingSetupForm);
